module.exports = __webpack_public_path__ + "img/personCheck.73befd56.svg";